import { useState } from "react";
// @mui
import {
  Stack,
  IconButton,
  Tooltip,
} from "@mui/material";
import { styled } from '@mui/material/styles';
import { tooltipClasses } from '@mui/material/Tooltip';
// hooks
import useResponsive from '../../../../hooks/useResponsive';
// components
import Iconify from '../../../../components/Iconify';
import SvgIconStyle from '../../../../components/SvgIconStyle';
import {
  DirectStepper,
} from './';

const NearTooltip = styled(({ theme, className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    marginRight: theme.spacing(0),
    ...theme.typography.body2,
    left: 10,
  },
}));


export default function DirectJobPostHeader({jobPost, step, goStep, isEdit, close, openMeetingDialog, openRejectHistoryDialog}) {
  const smUp = useResponsive('up', 'sm');
  const stepFix = jobPost?.position === 'developer' ? 1 : 0;
  const showStepper = smUp && step < (5 + stepFix) && step > 0;
  const showMobileStepper = !smUp && step < (5 + stepFix) && step > 0;
  const [openTooltip, setOpenTooltip] = useState(false);
  const [openEditTooltip, setOpenEditTooltip] = useState(isEdit);

  const closeTooltipOpenDialog = () => {
    setOpenTooltip(false);
    openMeetingDialog();
  }

  const closeEditTooltipOpenDialog= () => {
    setOpenEditTooltip(false);
    openRejectHistoryDialog();
  }

  return (
    <>
      <Stack direction="row" alignItems="flex-start" justifyContent="space-between" sx={{ mb: smUp ? showStepper ? 6 : 6 : 0 }}>
        <IconButton color="inherit" edge="start" onClick={() => goStep(step-1)} sx={{ ...((step === 0 || step === (5 + stepFix) || isEdit) && {visibility: 'hidden' }) }}>
          <Iconify icon="ic:chevron-left" sx={{ width: smUp ? 32 : 24 , height: smUp ? 32 : 24, color: (theme) => theme.palette.primary.main }} />
        </IconButton>
        {smUp && showStepper && (<DirectStepper step={step} jobPost={jobPost} />)}
        <Stack direction="row" spacing={1}>
          {!smUp && !isEdit && (step === 3 || (step === 2 && jobPost?.position !== 'developer')) && (
          // 도움 알림은 [작성]일때만
            <NearTooltip
              title="공고 작성이 어려우신가요?"
              arrow
              placement="left"
              open={openTooltip && (step === 3)}  // 2 에서는 닫아둔다
              disableInteractive
              disableTouchListener
              disableHoverListener
              disableFocusListener
              leaveTouchDelay={0}
            >
              <IconButton
                color="error" edge="end"
                onClick={closeTooltipOpenDialog}
                disableRipple
              >
                <SvgIconStyle src={`/icons/ic_headphone.svg`} sx={{ width: 28, height: 28, color: 'error.main' }} />
              </IconButton>
            </NearTooltip>
          )}
          {!smUp && isEdit && step < (stepFix + 4) && jobPost?.crew_reject_count > 0 && (
          // 거절사유는 [수정]일때만
            <NearTooltip
              title={`${jobPost?.crew_reject_count}명의 매칭 거절 사유 확인하기`}
              arrow
              placement="left"
              open={openEditTooltip}
              disableInteractive
              disableTouchListener
              disableHoverListener
              disableFocusListener
              leaveTouchDelay={0}
            >
              <IconButton
                color="error" edge="end"
                onClick={closeEditTooltipOpenDialog}
                disableRipple
              >
                <Iconify icon={"eva:alert-triangle-fill"} sx={{ width: 24, height: 24, color: 'error.main' }} />
              </IconButton>
            </NearTooltip>
          )}
          <IconButton color="inherit" edge="end" onClick={close}>
            <Iconify icon="ic:round-close" sx={{ width: smUp ? 32 : 24 , height: smUp ? 32 : 24, color: (theme) => theme.palette.text.disabled }} />
          </IconButton>
        </Stack>
      </Stack>
      {!smUp && showMobileStepper && (<Stack alignItems="center" justifyContent="center" sx={{ mb: smUp ? 0 : 4 }}><DirectStepper step={step} jobPost={jobPost} /></Stack>)}
      {!smUp && !showMobileStepper && <Stack sx={{ mb: 3 }} />}
    </>
  )
}
